// src/App.tsx
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './routes';
import { AuthProvider } from '../src/core/auth/context/AuthContext';
import { MyAccountProvider } from './core/auth/context/MyAccountContext';
import ToastContainer from './shared/ui/notifications/ToastContainer';
import { ModalProvider, Modal } from './shared/ui/modals';
import ProgressBar from './shared/ui/loading/ProgressBar';

const App = () => {
  return (
    <AuthProvider>
      <MyAccountProvider>
        <ModalProvider>
          <BrowserRouter>
            <ProgressBar>
              <AppRouter />
            </ProgressBar>
          </BrowserRouter>
          <ToastContainer />
          <Modal />
        </ModalProvider>
      </MyAccountProvider>
    </AuthProvider>
  );
};

export default App;